<template>	
	<div class="flex flex-col justify-center items-center w-full">
		<label class="label-number">{{label}}</label>
		<div class="container-input-number my-1 px-3 py-1 flex flex-row items-center" :class="{'btn-disabled': disabled}">			
			<feather-icon icon="MinusIcon" @click="!disabled?disminuir():null" :class="{'cursor-pointer': !disabled, 'aument':isDisableMinus}"/>
			<input 
				:class="{'btn-disabled': disabled}"				
				:readonly="disabled"				 
				v-model.number="number" 
				class="px-2 mx-2 text-center" 
				type="number" 
				step="3"
				v-on:input="validate(number)"				
				placeholder=""
				@blur="$emit('blur', number)">
			<feather-icon icon="PlusIcon" @click="!disabled?aumentar():null" :class="{'cursor-pointer': !disabled, 'aument':isDisablePlus}"/>				
		</div>
		<div class="showCurrency">			
			{{isMoney}}
		</div>	
	</div>
	
	
</template>

<script type="text/javascript">
	export default {
		props: {
			label: {
				type: String,
				required: false,
				default: ''

			},
			min: {
				type: Number,
				required: false,
				default: 0
			},
			max: {
				type: Number,
				required: false,
				default: 1000000000
			},
			disabled: {
				type: Boolean ,
				required: false,
				default: false
			},
			value: {
				type: Number
			},
			typeInput: {
				type: String, //number, currency
				required: false,
				default: 'number'
			}
		},
		watch: {
			value: function(value) {
				if(typeof(value) === 'number'){		
				  this.number = value;
				}else this.number = '';			
			},			
		},
		data() {
			return{
				number: this.value,	
				colorAument: false,			
			}
		},
		methods: {
			validate(number) {
				if(typeof(this.number) === 'string') return this.number = '';
				if(this.number > this.max) {
					this.number = this.max;
				}

				if(this.number < this.min) {
					this.number = this.min;
				}
				this.$emit('input', number);
			},			
			aumentar() {	
				if(typeof(this.number) === 'string') return this.number = 0;		
				if(this.number < this.max) {
					this.number = parseInt(this.number) + 1;
					this.$emit('input', this.number);
				}				
			},
			disminuir() {
				if(this.number > this.min) {
					this.number = parseInt(this.number) - 1;
					this.$emit('input', this.number)
				}
				
			},
			number_format(amount, decimals) {

			    amount += ''; 
			    amount = parseFloat(amount.replace(/[^0-9\.]/g, ''));

			    decimals = decimals || 0
			   
			    if (isNaN(amount) || amount === 0) 
			        return parseFloat(0).toFixed(decimals);
			    
			    amount = '' + amount.toFixed(decimals);

			    var amount_parts = amount.split('.'),
			        regexp = /(\d+)(\d{3})/;

			    while (regexp.test(amount_parts[0]))
			        amount_parts[0] = amount_parts[0].replace(regexp, '$1' + '.' + '$2');

			    return amount_parts.join('.');
			}
		},
		computed: {
			isDisablePlus() {
				return (this.number >= this.max || this.disabled);
			},
			isDisableMinus() {
				return (this.number <= this.min || this.disabled);
			},
			isMoney() {
				if(this.typeInput === 'currency') {
					return this.number_format(this.number);					
				}else {
					return null
				}
			}
		}
	}
</script>

<style type="text/css" lang="scss" scoped>
	input[type='number']{
		width: 100%;
		border: none;
		border-left: 1px solid rgba(0, 0, 0, 0.125);
		border-right: 1px solid rgba(0, 0, 0, 0.125);
	}

	input[type='text']:focus {
		outline:none !important;
	    outline-width: 0 !important;
	    box-shadow: none;
	    -moz-box-shadow: none;
	    -webkit-box-shadow: none;
	}

	input[type='number']::-webkit-inner-spin-button, 
	input[type='number']::-webkit-outer-spin-button { 
	  -webkit-appearance: none; 
	  margin: 0; 
	}

	input[type='number'] { -moz-appearance:textfield; }


	.container-input-number {
		border: 1px solid rgba(0, 0, 0, 0.125);
		width: 100%;
		max-width: 160px;
		border-radius: 3px;	
	}

	.cursor-pointer {
		cursor: pointer
	}

	.btn-disabled {
		background: #dddddd;
	}

	.aument {
		color: #dddddd;
	}

	.label-number {
		font-size: .85rem;
	    color: rgba(0,0,0,.7);
		
	}
	
</style>